export default {
  icon: {
    color: "none"
  }
};
